import React, { Component } from 'react';
import Toolbar from './../../components/Navigation/Toolbar/Toolbar';
import SideDrawer from './../../components/Navigation/SideDrawer/SideDrawer';
import classes from './Layout.css';
import Grid from '@material-ui/core/Grid';
import CssBaseline from '@material-ui/core/CssBaseline';

class Layout extends Component {

    state = {
        showSideDrawer: false
    }

    sideDrawerClosedHandler = () => {
        this.setState({ showSideDrawer: false });
    }

    sideDrawerToggleHandler = () => {
        this.setState((prevState) => { return { showSideDrawer: !prevState.showSideDrawer } });
    }

    handleAddToHomescreenClick = () => {
        alert('1. Open Share menu 2. Tap on Add to Home Screen button');
    };

    render() {
        let isLandingPage = false;
        if(window.location.pathname.indexOf('_lp') > -1) {
            isLandingPage = true;
        }
    
        let toolbar = isLandingPage ? null : <Toolbar drawerTogglerClicked={this.sideDrawerToggleHandler} />;
        let sidedrawer = isLandingPage ? null : <SideDrawer open={this.state.showSideDrawer} closed={this.sideDrawerClosedHandler} />;

        return <React.Fragment>
            <CssBaseline />
            {toolbar}
            {sidedrawer}
            <main className={isLandingPage ? classes.LP_Content : classes.Content}>
                <Grid container spacing={24}>
                    {this.props.children}
                </Grid>
            </main>
        </React.Fragment>
    }
}

export default Layout;